import { NewDynamicTab } from "../../../components/Page";
import { CgsTitle } from "../components";
import { ChattisgarhDiscomAnalysis } from "./Discom_Analysis";
import { ChhattisgarhTrend } from "./TrendAnalysis";
import { ChhattisgarhDCNetSchedule } from "./DC_Net_Schedule";
import { RajasthanDrawal } from "./Drawal";
import { RajasthanDrawalTrend } from "./Drawal_Trend";
import { ChhattisgarhForecast } from "./Forecast_Load";
import { ChhattisgarhDefaultDates } from "../../../config/DefaultDates";
import { TabSwitcher } from "../CGS_Dashboard";

export function CgsDemand() {
  return (
    <>
      <NewDynamicTab
        defaultDates={ChhattisgarhDefaultDates}
        header="Demand"
        trendTabs={["Trend Analysis", "Restricted Demand Trend Analysis"]}
        headerPrefixComponent={<TabSwitcher />}
        middleComponent={<CgsTitle />}
        tabs={{
          "Discom Load ": <ChattisgarhDiscomAnalysis />,
          "Trend Analysis": <ChhattisgarhTrend />,
          "Forecast Discom Load": <ChhattisgarhForecast />,
          "DC vs Actual": <ChhattisgarhDCNetSchedule />,
          "Restricted Demand": <RajasthanDrawal />,
          "Restricted Demand Trend Analysis": <RajasthanDrawalTrend />,
        }}
        disabledTabs={["Restricted Demand", "Restricted Demand Trend Analysis"]}
      />
    </>
  );
}
